import { Component, Input } from '@angular/core';
import { ActionItemLifeCycle } from '../models/action-item-life-cycle';
import { AuditConstants } from '../../../../../shared/constants/audit-constants';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-action-item-audit-life-cycle',
  templateUrl: './action-item-audit-life-cycle.component.html',
  styleUrls: ['./action-item-audit-life-cycle.component.scss']
})
export class ActionItemAuditLifeCycleComponent {
  @Input() auditLifecycleInput: ActionItemLifeCycle[] = [];
  private statusOrder = AuditConstants.actionItemStatusOrder;
  ngOnInit(): void {
    this.calculateStatusForLifeCycleFlow();
  }

  calculateStatusForLifeCycleFlow = () => {
    const datePipe = new DatePipe('en-US');
    this.auditLifecycleInput.forEach((entity, i) => {
      const currentPhaseIndex = this.statusOrder.indexOf(entity.statusName);
      const prevEntity = this.auditLifecycleInput[i - 1];
      const prevPhaseIndex = prevEntity ? this.statusOrder.indexOf(prevEntity.statusName) : -1;
      entity.arrowColor = currentPhaseIndex > prevPhaseIndex ? 'green-arrow' : 'red-arrow';
      entity.userDetails = entity.userDetails
        .map((user) => ({ ...user, date: datePipe.transform(user.transactionDate, 'dd-MMM-yy'), }))
        .sort((a, b) => {
          if (!a.date || !b.date) {
            return 0;
          }
          return a.date.localeCompare(b.date) || a.userName.localeCompare(b.userName);
        });
    });
  }

}
